import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { queueApiService } from "@/services/queueApi.service";

export const useMecanicas = () => {
  return useQuery({
    queryKey: ["mecanicas"],
    queryFn: () => queueApiService.listQueues(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteMecanica = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => queueApiService.deleteQueue(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["mecanicas"] });
    },
  });
};
